module.exports = __webpack_public_path__ + "static/media/fslogo.2bd8594b.webp";